import { render, staticRenderFns } from "./CustomizeMetalY.vue?vue&type=template&id=6540c9ca&scoped=true"
import script from "./CustomizeMetalY.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalY.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalY.vue?vue&type=style&index=0&id=6540c9ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6540c9ca",
  null
  
)

export default component.exports